module.exports = __webpack_public_path__ + "static/p2-38cd0129277fddb5b0d99daeea4a538e.jpg";